<template>
    <div class="flex items-center w-full h-full justify-center">
        <div class="animate-spin w-16 h-16">
            <loading class="animate-spin" :size="64" />
        </div>
    </div>
</template>

<script setup lang="ts">
//@ts-ignore
import Loading from 'vue-material-design-icons/Loading.vue'
</script>
